import {
  companiesPath,
  membersPath,
  profilePath,
  settingsLabelsPath,
  settingsPath,
  teamsPath,
  workspaceRootPath,
} from '@/lib/linear-paths';
import type { SharedPageProps } from '@/types/shared';
import { Link, usePage } from '@inertiajs/react';
import { ArrowLeft } from 'lucide-react';

function active(currentPath: string, url: string): boolean {
  return currentPath === url || currentPath.startsWith(`${url}/`);
}

export default function SettingsSidebar() {
  const { currentPath, currentCompany } = usePage<SharedPageProps>().props;
  const url = usePage().url;
  const tab = new URLSearchParams(url.split('?')[1] ?? '').get('tab');
  const onSettings = currentPath === settingsPath();

  return (
    <aside className="ln-sidebar">
      <div className="ln-sidebar-header">
        <Link
          href={workspaceRootPath()}
          className="ln-nav-item"
          style={{ margin: 0, width: '100%' }}
        >
          <ArrowLeft size={14} />
          <span>Back to app</span>
        </Link>
      </div>
      <nav className="ln-nav">
        <div className="ln-section-label" style={{ cursor: 'default' }}>
          Account
        </div>
        <Link
          href={profilePath()}
          className="ln-nav-item"
          data-active={active(currentPath, profilePath()) ? 'true' : 'false'}
        >
          <span>Profile and security</span>
        </Link>
        <Link
          href={`${settingsPath()}?tab=preferences`}
          className="ln-nav-item"
          data-active={tab === 'preferences' ? 'true' : 'false'}
        >
          <span>Preferences</span>
        </Link>
        <Link
          href={`${settingsPath()}?tab=notifications`}
          className="ln-nav-item"
          data-active={tab === 'notifications' ? 'true' : 'false'}
        >
          <span>Notifications</span>
        </Link>
        <Link
          href={`${settingsPath()}?tab=shortcuts`}
          className="ln-nav-item"
          data-active={tab === 'shortcuts' ? 'true' : 'false'}
        >
          <span>Shortcuts</span>
        </Link>

        <div className="ln-section">
          <div className="ln-section-label" style={{ cursor: 'default' }}>
            {currentCompany?.name ?? 'Workspace'}
          </div>
          <Link
            href={settingsPath()}
            className="ln-nav-item"
            data-active={onSettings && tab === null ? 'true' : 'false'}
          >
            <span>General</span>
          </Link>
          <Link
            href={membersPath()}
            className="ln-nav-item"
            data-active={active(currentPath, membersPath()) ? 'true' : 'false'}
          >
            <span>Members</span>
          </Link>
          <Link
            href={settingsLabelsPath()}
            className="ln-nav-item"
            data-active={active(currentPath, settingsLabelsPath()) ? 'true' : 'false'}
          >
            <span>Labels</span>
          </Link>
          <Link
            href={teamsPath()}
            className="ln-nav-item"
            data-active={active(currentPath, teamsPath()) ? 'true' : 'false'}
          >
            <span>Teams</span>
          </Link>
          <Link href={companiesPath()} className="ln-nav-item">
            <span>Workspaces</span>
          </Link>
        </div>
      </nav>
    </aside>
  );
}
